module.exports = __webpack_public_path__ + "img/niu17.7f7345bb.jpg";